interface IProps {
  titre?: string;
  titreClass?: string;
  titreCol?:string;
  donnees?: string[] | number[];
  elem?: JSX.Element;
  prefixe?: string;
  suffixe?: string;
  donneeCol?:string;
}

const RowDetailList: React.FC<IProps> = ({
  titre,
  donnees,
  prefixe = "",
  suffixe = "",
  elem,
  titreClass,
  titreCol,
  donneeCol,
}: IProps) => {
  const N = (a : any) => a === null ? "" : a;

  return (
    <div className="row">
      <div className={`col-${titreCol ? titreCol : "12"} ${titreClass ? titreClass : "pae-detail-label"}`} style={{ textAlign: 'left' }}>
        <b>{titre}</b>
      </div>
      <div className={`col-${donneeCol ? donneeCol : "12"}`} style={{ textAlign: 'left' }}>
    {donnees?.map((item, index) => (
      <div key={index} >
        {elem ? elem : donnees ? N(prefixe) + item + N(suffixe) : "_"}
      </div>
    ))}
  </div>
    </div>
  )
};

export default RowDetailList;
